import { render } from "./SchemaPanel.vue?vue&type=template&id=16b65222&scoped=true&ts=true"
import script from "./SchemaPanel.vue?vue&type=script&lang=ts"
export * from "./SchemaPanel.vue?vue&type=script&lang=ts"

import "./SchemaPanel.vue?vue&type=style&index=0&id=16b65222&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b65222"]])

export default __exports__